// Vendor
import $ from 'jquery';

$(document).on('click', '[data-print-page]', (event) => {
  event.preventDefault();
  window.print();
});
